import { gql } from '@apollo/client';

export const GENERATE_PICKUP_PROGRESS_DOWNLOAD_REPORT = gql`
    query GeneratePickupProgressDownloadReport(
        $filters: PickupAppointmentStatisticsFiltersTypeInput!
        $timezone: String
    ) {
        generatePickupProgressDownloadReport(
            filters: $filters
            timezone: $timezone
        )
    }
`;
